import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "mapper-config-editor"
  }, [_vm.kind === 'packet' ? _c(VTabs, {
    staticClass: "mapper-config-editor__tabs",
    attrs: {
      "value": _vm.activeTabIndex,
      "height": "36"
    },
    on: {
      "change": function ($event) {
        return _vm.switchView($event === 1 ? 'code' : 'builder');
      }
    }
  }, [_c(VTab, {
    attrs: {
      "disabled": !_vm.representable,
      "data-testid": "mapper-config-view-builder"
    }
  }, [_c(VIcon, {
    attrs: {
      "left": "",
      "size": "14"
    }
  }, [_vm._v("fal fa-sliders-h")]), _vm._v("\n      " + _vm._s(_vm.$i18n_t('Bridges.mapperBuilder.tabs.builder')) + "\n    ")], 1), _c(VTab, {
    attrs: {
      "data-testid": "mapper-config-view-code"
    }
  }, [_c(VIcon, {
    attrs: {
      "left": "",
      "size": "14"
    }
  }, [_vm._v("fal fa-code")]), _vm._v("\n      " + _vm._s(_vm.$i18n_t('Bridges.mapperBuilder.tabs.code')) + "\n    ")], 1)], 1) : _vm._e(), _vm.kind === 'packet' && !_vm.representable ? _c(VAlert, {
    staticClass: "mapper-config-editor__banner",
    attrs: {
      "dense": "",
      "text": "",
      "type": "warning",
      "data-testid": "mapper-config-unrepresentable"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$i18n_t('Bridges.mapperBuilder.unrepresentable')) + "\n  ")]) : _vm._e(), _c('div', {
    class: ['mapper-config-editor__status', _vm.statusError ? 'is-invalid' : 'is-valid']
  }, [_c(VIcon, {
    attrs: {
      "size": "12",
      "color": _vm.statusError ? 'error' : 'success'
    }
  }, [_vm._v("\n      " + _vm._s(_vm.statusError ? 'fal fa-exclamation-triangle' : 'fal fa-check') + "\n    ")]), _c('span', {
    attrs: {
      "data-testid": "mapper-config-status"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.statusError || _vm.$i18n_t('Bridges.mapperBuilder.status.valid')) + "\n    ")])], 1), _vm.kind === 'packet' ? _c('mapper-config-builder', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeView === 'builder',
      expression: "activeView === 'builder'"
    }],
    attrs: {
      "value": _vm.value,
      "format": _vm.mode,
      "disabled": _vm.disabled
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input', $event);
      },
      "update:format": function ($event) {
        return _vm.switchMode($event);
      }
    }
  }) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeView === 'code',
      expression: "activeView === 'code'"
    }]
  }, [_c('div', {
    staticClass: "mapper-config-editor__toolbar"
  }, [_c(VBtnToggle, {
    attrs: {
      "value": _vm.mode,
      "dense": "",
      "mandatory": ""
    },
    on: {
      "change": function ($event) {
        return _vm.switchMode($event);
      }
    }
  }, [_c(VBtn, {
    attrs: {
      "value": "json",
      "disabled": _vm.disabled,
      "small": "",
      "data-testid": "mapper-config-mode-json"
    }
  }, [_vm._v("JSON")]), _c(VBtn, {
    attrs: {
      "value": "yaml",
      "disabled": _vm.disabled,
      "small": "",
      "data-testid": "mapper-config-mode-yaml"
    }
  }, [_vm._v("YAML")])], 1), _c(VBtn, {
    attrs: {
      "disabled": _vm.disabled,
      "small": "",
      "text": "",
      "data-testid": "mapper-config-format"
    },
    on: {
      "click": _vm.formatCurrentText
    }
  }, [_c(VIcon, {
    attrs: {
      "left": "",
      "size": "12"
    }
  }, [_vm._v("fal fa-code")]), _vm._v("\n        " + _vm._s(_vm.$i18n_t('Bridges.mapperBuilder.code.format')) + "\n      ")], 1)], 1), _c('div', {
    staticClass: "mapper-config-editor__guide"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$i18n_t('Bridges.mapperBuilder.guide.title')))]), _c('ul', [_c('li', [_c('code', [_vm._v(_vm._s(_vm.kind === 'output' ? '{ "path": "reading.value" }' : '{ "path": "payload.temperature" }'))]), _vm._v("\n          " + _vm._s(_vm.$i18n_t('Bridges.mapperBuilder.guide.path')) + "\n        ")]), _c('li', [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Bridges.mapperBuilder.guide.literal')) + "\n          "), _c('code', [_vm._v("\"battery\"")]), _vm._v("\n          " + _vm._s(_vm.$i18n_t('Bridges.mapperBuilder.guide.or')) + "\n          "), _c('code', [_vm._v("1001")])]), _vm.kind === 'packet' ? _c('li', [_c('code', [_vm._v("{ \"capture\": \"device\" }")]), _vm._v("\n          " + _vm._s(_vm.$i18n_t('Bridges.mapperBuilder.guide.capture')) + "\n          "), _c('code', [_vm._v("input.topicPattern")])]) : _vm._e(), _c('li', [_c('code', [_vm._v("{ \"lookup\": { \"table\": \"deviceToTwin\", \"from\": { \"path\": \"deviceId\" } } }")]), _vm._v("\n          " + _vm._s(_vm.$i18n_t('Bridges.mapperBuilder.guide.lookup')) + "\n          "), _c('code', [_vm._v("lookups.deviceToTwin")])]), _c('li', [_c('code', [_vm._v("transforms")]), _vm._v("\n          " + _vm._s(_vm.$i18n_t('Bridges.mapperBuilder.guide.transforms')) + "\n          "), _c('code', [_vm._v("number, string, boolean, timestampIso, multiply, divide, scalePow10, default")])])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.monacoFailed,
      expression: "!monacoFailed"
    }],
    ref: "monacoHost",
    staticClass: "mapper-config-editor__monaco"
  }), _vm.monacoFailed ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.text,
      expression: "text"
    }],
    staticClass: "mapper-config-editor__fallback",
    attrs: {
      "readonly": _vm.disabled,
      "disabled": _vm.disabled,
      "data-testid": "mapper-config-text"
    },
    domProps: {
      "value": _vm.text
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.text = $event.target.value;
      }, _vm.emitParsedValue]
    }
  }) : _vm._e()])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };